<template>
  <section class="pa-2">
    <editPermissionComponent
      v-if="this.$route.params.roleid && this.$route.params.rolename"
      :roleName="roleName"
      :roleId="roleId"
    ></editPermissionComponent>
  </section>
</template>

<script>
import editPermissionComponent from "./components/permissionComponent.vue";
export default {
  name: "EditRole",
  components: { editPermissionComponent },
  data() {
    return {
      roleName: this.$route.params.rolename,
      roleId: this.$route.params.roleid,
    };
  },
  mounted() {
    console.log("route params", this.$route.params.rolename);
  },
  methods: {},
};
</script>

<style></style>
